/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as LoginRouteImport } from './routes/login'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as AppIndexRouteImport } from './routes/_app.index'
import { Route as AppAbonnementRouteImport } from './routes/_app.abonnement'
import { Route as AppDoctolibRouteImport } from './routes/_app.doctolib'
import { Route as AppFileAttenteRouteImport } from './routes/_app.file-attente'
import { Route as AppMessagesRouteImport } from './routes/_app.messages'
import { Route as AppReglagesRouteImport } from './routes/_app.reglages'
import { Route as AppReviewsRouteImport } from './routes/_app.reviews'
import { Route as AppSettingsRouteImport } from './routes/_app.settings'
import { Route as AppUtilisateursRouteImport } from './routes/_app.utilisateurs'
import { Route as ConnexionGoogleRouteImport } from './routes/connexion.google'
import { Route as ReviewsTokenRouteImport } from './routes/reviews.$token'
import { Route as AppAbonnementIndexRouteImport } from './routes/_app.abonnement.index'
import { Route as AppAbonnementPaiementsRouteImport } from './routes/_app.abonnement.paiements'
import { Route as AppMessagesIndexRouteImport } from './routes/_app.messages.index'
import { Route as AppMessagesIdRouteImport } from './routes/_app.messages.$id'
import { Route as AppReviewsIndexRouteImport } from './routes/_app.reviews.index'
import { Route as AppReviewsCustomizeRouteImport } from './routes/_app.reviews.customize'
import { Route as AppReviewsEmptyRouteImport } from './routes/_app.reviews.empty'
import { Route as AppReviewsStatsRouteImport } from './routes/_app.reviews.stats'
import { Route as AppSettingsIndexRouteImport } from './routes/_app.settings.index'
import { Route as AppSettingsAccountRouteImport } from './routes/_app.settings.account'
import { Route as AppSettingsPracticeRouteImport } from './routes/_app.settings.practice'
import { Route as AppSettingsReviewsRouteImport } from './routes/_app.settings.reviews'
import { Route as AppSettingsSendingRouteImport } from './routes/_app.settings.sending'
import { Route as AppSettingsSignaturesRouteImport } from './routes/_app.settings.signatures'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAbonnementRoute = AppAbonnementRouteImport.update({
  id: '/abonnement',
  path: '/abonnement',
  getParentRoute: () => AppRoute,
} as any)
const AppDoctolibRoute = AppDoctolibRouteImport.update({
  id: '/doctolib',
  path: '/doctolib',
  getParentRoute: () => AppRoute,
} as any)
const AppFileAttenteRoute = AppFileAttenteRouteImport.update({
  id: '/file-attente',
  path: '/file-attente',
  getParentRoute: () => AppRoute,
} as any)
const AppMessagesRoute = AppMessagesRouteImport.update({
  id: '/messages',
  path: '/messages',
  getParentRoute: () => AppRoute,
} as any)
const AppReglagesRoute = AppReglagesRouteImport.update({
  id: '/reglages',
  path: '/reglages',
  getParentRoute: () => AppRoute,
} as any)
const AppReviewsRoute = AppReviewsRouteImport.update({
  id: '/reviews',
  path: '/reviews',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppUtilisateursRoute = AppUtilisateursRouteImport.update({
  id: '/utilisateurs',
  path: '/utilisateurs',
  getParentRoute: () => AppRoute,
} as any)
const ConnexionGoogleRoute = ConnexionGoogleRouteImport.update({
  id: '/connexion/google',
  path: '/connexion/google',
  getParentRoute: () => rootRouteImport,
} as any)
const ReviewsTokenRoute = ReviewsTokenRouteImport.update({
  id: '/reviews/$token',
  path: '/reviews/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const AppAbonnementIndexRoute = AppAbonnementIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppAbonnementRoute,
} as any)
const AppAbonnementPaiementsRoute = AppAbonnementPaiementsRouteImport.update({
  id: '/paiements',
  path: '/paiements',
  getParentRoute: () => AppAbonnementRoute,
} as any)
const AppMessagesIndexRoute = AppMessagesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppMessagesRoute,
} as any)
const AppMessagesIdRoute = AppMessagesIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AppMessagesRoute,
} as any)
const AppReviewsIndexRoute = AppReviewsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppReviewsRoute,
} as any)
const AppReviewsCustomizeRoute = AppReviewsCustomizeRouteImport.update({
  id: '/customize',
  path: '/customize',
  getParentRoute: () => AppReviewsRoute,
} as any)
const AppReviewsEmptyRoute = AppReviewsEmptyRouteImport.update({
  id: '/empty',
  path: '/empty',
  getParentRoute: () => AppReviewsRoute,
} as any)
const AppReviewsStatsRoute = AppReviewsStatsRouteImport.update({
  id: '/stats',
  path: '/stats',
  getParentRoute: () => AppReviewsRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsAccountRoute = AppSettingsAccountRouteImport.update({
  id: '/account',
  path: '/account',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsPracticeRoute = AppSettingsPracticeRouteImport.update({
  id: '/practice',
  path: '/practice',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsReviewsRoute = AppSettingsReviewsRouteImport.update({
  id: '/reviews',
  path: '/reviews',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsSendingRoute = AppSettingsSendingRouteImport.update({
  id: '/sending',
  path: '/sending',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsSignaturesRoute = AppSettingsSignaturesRouteImport.update({
  id: '/signatures',
  path: '/signatures',
  getParentRoute: () => AppSettingsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/abonnement': typeof AppAbonnementRouteWithChildren
  '/doctolib': typeof AppDoctolibRoute
  '/file-attente': typeof AppFileAttenteRoute
  '/messages': typeof AppMessagesRouteWithChildren
  '/reglages': typeof AppReglagesRoute
  '/reviews': typeof AppReviewsRouteWithChildren
  '/settings': typeof AppSettingsRouteWithChildren
  '/utilisateurs': typeof AppUtilisateursRoute
  '/connexion/google': typeof ConnexionGoogleRoute
  '/reviews/$token': typeof ReviewsTokenRoute
  '/abonnement/paiements': typeof AppAbonnementPaiementsRoute
  '/messages/$id': typeof AppMessagesIdRoute
  '/reviews/customize': typeof AppReviewsCustomizeRoute
  '/reviews/empty': typeof AppReviewsEmptyRoute
  '/reviews/stats': typeof AppReviewsStatsRoute
  '/settings/account': typeof AppSettingsAccountRoute
  '/settings/practice': typeof AppSettingsPracticeRoute
  '/settings/reviews': typeof AppSettingsReviewsRoute
  '/settings/sending': typeof AppSettingsSendingRoute
  '/settings/signatures': typeof AppSettingsSignaturesRoute
  '/abonnement/': typeof AppAbonnementIndexRoute
  '/messages/': typeof AppMessagesIndexRoute
  '/reviews/': typeof AppReviewsIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/doctolib': typeof AppDoctolibRoute
  '/file-attente': typeof AppFileAttenteRoute
  '/reglages': typeof AppReglagesRoute
  '/utilisateurs': typeof AppUtilisateursRoute
  '/connexion/google': typeof ConnexionGoogleRoute
  '/reviews/$token': typeof ReviewsTokenRoute
  '/': typeof AppIndexRoute
  '/abonnement/paiements': typeof AppAbonnementPaiementsRoute
  '/messages/$id': typeof AppMessagesIdRoute
  '/reviews/customize': typeof AppReviewsCustomizeRoute
  '/reviews/empty': typeof AppReviewsEmptyRoute
  '/reviews/stats': typeof AppReviewsStatsRoute
  '/settings/account': typeof AppSettingsAccountRoute
  '/settings/practice': typeof AppSettingsPracticeRoute
  '/settings/reviews': typeof AppSettingsReviewsRoute
  '/settings/sending': typeof AppSettingsSendingRoute
  '/settings/signatures': typeof AppSettingsSignaturesRoute
  '/abonnement': typeof AppAbonnementIndexRoute
  '/messages': typeof AppMessagesIndexRoute
  '/reviews': typeof AppReviewsIndexRoute
  '/settings': typeof AppSettingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/_app/abonnement': typeof AppAbonnementRouteWithChildren
  '/_app/doctolib': typeof AppDoctolibRoute
  '/_app/file-attente': typeof AppFileAttenteRoute
  '/_app/messages': typeof AppMessagesRouteWithChildren
  '/_app/reglages': typeof AppReglagesRoute
  '/_app/reviews': typeof AppReviewsRouteWithChildren
  '/_app/settings': typeof AppSettingsRouteWithChildren
  '/_app/utilisateurs': typeof AppUtilisateursRoute
  '/connexion/google': typeof ConnexionGoogleRoute
  '/reviews/$token': typeof ReviewsTokenRoute
  '/_app/': typeof AppIndexRoute
  '/_app/abonnement/paiements': typeof AppAbonnementPaiementsRoute
  '/_app/messages/$id': typeof AppMessagesIdRoute
  '/_app/reviews/customize': typeof AppReviewsCustomizeRoute
  '/_app/reviews/empty': typeof AppReviewsEmptyRoute
  '/_app/reviews/stats': typeof AppReviewsStatsRoute
  '/_app/settings/account': typeof AppSettingsAccountRoute
  '/_app/settings/practice': typeof AppSettingsPracticeRoute
  '/_app/settings/reviews': typeof AppSettingsReviewsRoute
  '/_app/settings/sending': typeof AppSettingsSendingRoute
  '/_app/settings/signatures': typeof AppSettingsSignaturesRoute
  '/_app/abonnement/': typeof AppAbonnementIndexRoute
  '/_app/messages/': typeof AppMessagesIndexRoute
  '/_app/reviews/': typeof AppReviewsIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/register'
    | '/abonnement'
    | '/doctolib'
    | '/file-attente'
    | '/messages'
    | '/reglages'
    | '/reviews'
    | '/settings'
    | '/utilisateurs'
    | '/connexion/google'
    | '/reviews/$token'
    | '/abonnement/paiements'
    | '/messages/$id'
    | '/reviews/customize'
    | '/reviews/empty'
    | '/reviews/stats'
    | '/settings/account'
    | '/settings/practice'
    | '/settings/reviews'
    | '/settings/sending'
    | '/settings/signatures'
    | '/abonnement/'
    | '/messages/'
    | '/reviews/'
    | '/settings/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/register'
    | '/doctolib'
    | '/file-attente'
    | '/reglages'
    | '/utilisateurs'
    | '/connexion/google'
    | '/reviews/$token'
    | '/'
    | '/abonnement/paiements'
    | '/messages/$id'
    | '/reviews/customize'
    | '/reviews/empty'
    | '/reviews/stats'
    | '/settings/account'
    | '/settings/practice'
    | '/settings/reviews'
    | '/settings/sending'
    | '/settings/signatures'
    | '/abonnement'
    | '/messages'
    | '/reviews'
    | '/settings'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/register'
    | '/_app/abonnement'
    | '/_app/doctolib'
    | '/_app/file-attente'
    | '/_app/messages'
    | '/_app/reglages'
    | '/_app/reviews'
    | '/_app/settings'
    | '/_app/utilisateurs'
    | '/connexion/google'
    | '/reviews/$token'
    | '/_app/'
    | '/_app/abonnement/paiements'
    | '/_app/messages/$id'
    | '/_app/reviews/customize'
    | '/_app/reviews/empty'
    | '/_app/reviews/stats'
    | '/_app/settings/account'
    | '/_app/settings/practice'
    | '/_app/settings/reviews'
    | '/_app/settings/sending'
    | '/_app/settings/signatures'
    | '/_app/abonnement/'
    | '/_app/messages/'
    | '/_app/reviews/'
    | '/_app/settings/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  RegisterRoute: typeof RegisterRoute
  ConnexionGoogleRoute: typeof ConnexionGoogleRoute
  ReviewsTokenRoute: typeof ReviewsTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/abonnement': {
      id: '/_app/abonnement'
      path: '/abonnement'
      fullPath: '/abonnement'
      preLoaderRoute: typeof AppAbonnementRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/doctolib': {
      id: '/_app/doctolib'
      path: '/doctolib'
      fullPath: '/doctolib'
      preLoaderRoute: typeof AppDoctolibRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/file-attente': {
      id: '/_app/file-attente'
      path: '/file-attente'
      fullPath: '/file-attente'
      preLoaderRoute: typeof AppFileAttenteRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/messages': {
      id: '/_app/messages'
      path: '/messages'
      fullPath: '/messages'
      preLoaderRoute: typeof AppMessagesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reglages': {
      id: '/_app/reglages'
      path: '/reglages'
      fullPath: '/reglages'
      preLoaderRoute: typeof AppReglagesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/reviews': {
      id: '/_app/reviews'
      path: '/reviews'
      fullPath: '/reviews'
      preLoaderRoute: typeof AppReviewsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/utilisateurs': {
      id: '/_app/utilisateurs'
      path: '/utilisateurs'
      fullPath: '/utilisateurs'
      preLoaderRoute: typeof AppUtilisateursRouteImport
      parentRoute: typeof AppRoute
    }
    '/connexion/google': {
      id: '/connexion/google'
      path: '/connexion/google'
      fullPath: '/connexion/google'
      preLoaderRoute: typeof ConnexionGoogleRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reviews/$token': {
      id: '/reviews/$token'
      path: '/reviews/$token'
      fullPath: '/reviews/$token'
      preLoaderRoute: typeof ReviewsTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/abonnement/': {
      id: '/_app/abonnement/'
      path: '/'
      fullPath: '/abonnement/'
      preLoaderRoute: typeof AppAbonnementIndexRouteImport
      parentRoute: typeof AppAbonnementRoute
    }
    '/_app/abonnement/paiements': {
      id: '/_app/abonnement/paiements'
      path: '/paiements'
      fullPath: '/abonnement/paiements'
      preLoaderRoute: typeof AppAbonnementPaiementsRouteImport
      parentRoute: typeof AppAbonnementRoute
    }
    '/_app/messages/': {
      id: '/_app/messages/'
      path: '/'
      fullPath: '/messages/'
      preLoaderRoute: typeof AppMessagesIndexRouteImport
      parentRoute: typeof AppMessagesRoute
    }
    '/_app/messages/$id': {
      id: '/_app/messages/$id'
      path: '/$id'
      fullPath: '/messages/$id'
      preLoaderRoute: typeof AppMessagesIdRouteImport
      parentRoute: typeof AppMessagesRoute
    }
    '/_app/reviews/': {
      id: '/_app/reviews/'
      path: '/'
      fullPath: '/reviews/'
      preLoaderRoute: typeof AppReviewsIndexRouteImport
      parentRoute: typeof AppReviewsRoute
    }
    '/_app/reviews/customize': {
      id: '/_app/reviews/customize'
      path: '/customize'
      fullPath: '/reviews/customize'
      preLoaderRoute: typeof AppReviewsCustomizeRouteImport
      parentRoute: typeof AppReviewsRoute
    }
    '/_app/reviews/empty': {
      id: '/_app/reviews/empty'
      path: '/empty'
      fullPath: '/reviews/empty'
      preLoaderRoute: typeof AppReviewsEmptyRouteImport
      parentRoute: typeof AppReviewsRoute
    }
    '/_app/reviews/stats': {
      id: '/_app/reviews/stats'
      path: '/stats'
      fullPath: '/reviews/stats'
      preLoaderRoute: typeof AppReviewsStatsRouteImport
      parentRoute: typeof AppReviewsRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/account': {
      id: '/_app/settings/account'
      path: '/account'
      fullPath: '/settings/account'
      preLoaderRoute: typeof AppSettingsAccountRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/practice': {
      id: '/_app/settings/practice'
      path: '/practice'
      fullPath: '/settings/practice'
      preLoaderRoute: typeof AppSettingsPracticeRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/reviews': {
      id: '/_app/settings/reviews'
      path: '/reviews'
      fullPath: '/settings/reviews'
      preLoaderRoute: typeof AppSettingsReviewsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/sending': {
      id: '/_app/settings/sending'
      path: '/sending'
      fullPath: '/settings/sending'
      preLoaderRoute: typeof AppSettingsSendingRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/signatures': {
      id: '/_app/settings/signatures'
      path: '/signatures'
      fullPath: '/settings/signatures'
      preLoaderRoute: typeof AppSettingsSignaturesRouteImport
      parentRoute: typeof AppSettingsRoute
    }
  }
}

interface AppAbonnementRouteChildren {
  AppAbonnementPaiementsRoute: typeof AppAbonnementPaiementsRoute
  AppAbonnementIndexRoute: typeof AppAbonnementIndexRoute
}

const AppAbonnementRouteChildren: AppAbonnementRouteChildren = {
  AppAbonnementPaiementsRoute: AppAbonnementPaiementsRoute,
  AppAbonnementIndexRoute: AppAbonnementIndexRoute,
}

const AppAbonnementRouteWithChildren = AppAbonnementRoute._addFileChildren(
  AppAbonnementRouteChildren,
)

interface AppMessagesRouteChildren {
  AppMessagesIdRoute: typeof AppMessagesIdRoute
  AppMessagesIndexRoute: typeof AppMessagesIndexRoute
}

const AppMessagesRouteChildren: AppMessagesRouteChildren = {
  AppMessagesIdRoute: AppMessagesIdRoute,
  AppMessagesIndexRoute: AppMessagesIndexRoute,
}

const AppMessagesRouteWithChildren = AppMessagesRoute._addFileChildren(
  AppMessagesRouteChildren,
)

interface AppReviewsRouteChildren {
  AppReviewsCustomizeRoute: typeof AppReviewsCustomizeRoute
  AppReviewsEmptyRoute: typeof AppReviewsEmptyRoute
  AppReviewsStatsRoute: typeof AppReviewsStatsRoute
  AppReviewsIndexRoute: typeof AppReviewsIndexRoute
}

const AppReviewsRouteChildren: AppReviewsRouteChildren = {
  AppReviewsCustomizeRoute: AppReviewsCustomizeRoute,
  AppReviewsEmptyRoute: AppReviewsEmptyRoute,
  AppReviewsStatsRoute: AppReviewsStatsRoute,
  AppReviewsIndexRoute: AppReviewsIndexRoute,
}

const AppReviewsRouteWithChildren = AppReviewsRoute._addFileChildren(
  AppReviewsRouteChildren,
)

interface AppSettingsRouteChildren {
  AppSettingsAccountRoute: typeof AppSettingsAccountRoute
  AppSettingsPracticeRoute: typeof AppSettingsPracticeRoute
  AppSettingsReviewsRoute: typeof AppSettingsReviewsRoute
  AppSettingsSendingRoute: typeof AppSettingsSendingRoute
  AppSettingsSignaturesRoute: typeof AppSettingsSignaturesRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
}

const AppSettingsRouteChildren: AppSettingsRouteChildren = {
  AppSettingsAccountRoute: AppSettingsAccountRoute,
  AppSettingsPracticeRoute: AppSettingsPracticeRoute,
  AppSettingsReviewsRoute: AppSettingsReviewsRoute,
  AppSettingsSendingRoute: AppSettingsSendingRoute,
  AppSettingsSignaturesRoute: AppSettingsSignaturesRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
}

const AppSettingsRouteWithChildren = AppSettingsRoute._addFileChildren(
  AppSettingsRouteChildren,
)

interface AppRouteChildren {
  AppAbonnementRoute: typeof AppAbonnementRouteWithChildren
  AppDoctolibRoute: typeof AppDoctolibRoute
  AppFileAttenteRoute: typeof AppFileAttenteRoute
  AppMessagesRoute: typeof AppMessagesRouteWithChildren
  AppReglagesRoute: typeof AppReglagesRoute
  AppReviewsRoute: typeof AppReviewsRouteWithChildren
  AppSettingsRoute: typeof AppSettingsRouteWithChildren
  AppUtilisateursRoute: typeof AppUtilisateursRoute
  AppIndexRoute: typeof AppIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAbonnementRoute: AppAbonnementRouteWithChildren,
  AppDoctolibRoute: AppDoctolibRoute,
  AppFileAttenteRoute: AppFileAttenteRoute,
  AppMessagesRoute: AppMessagesRouteWithChildren,
  AppReglagesRoute: AppReglagesRoute,
  AppReviewsRoute: AppReviewsRouteWithChildren,
  AppSettingsRoute: AppSettingsRouteWithChildren,
  AppUtilisateursRoute: AppUtilisateursRoute,
  AppIndexRoute: AppIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  RegisterRoute: RegisterRoute,
  ConnexionGoogleRoute: ConnexionGoogleRoute,
  ReviewsTokenRoute: ReviewsTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
